// removed by extract-text-webpack-plugin
module.exports = {"container":"h4_g","imageContainer":"h4_cq","image":"h4_l","smallContainer":"h4_h5 h4_g","smallImageContainer":"h4_h6 h4_cq"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventLogo/styles.module.css
// module id = 1101
// module chunks = 27